import React, { useCallback, useRef, useMemo, useState, useEffect } from 'react';
import { Column, DataGridTypes } from 'devextreme-react/data-grid';
import { Item as TabItem } from "devextreme-react/tab-panel";
import Form, { GroupItem, SimpleItem, Label } from "devextreme-react/form";
import ICommandite from "../../models/ICommandite";
import { FormListBase, FormListBaseTab, FormListBaseGrid, FormListBaseToolbar } from '../base';
import { Button } from 'devextreme-react';
import useCustomDataSource, { Mode } from "../../hooks/useCustomDataSource";
import FormSysteme from '../../components/forms/form-systeme';
import { FileUploader, } from 'devextreme-react/file-uploader';
import './gestion-commandite.css'

export default function GestionCommandites() {
  const clientFormDataSource = useCustomDataSource<ICommandite, ICommandite>({ path: "commandite", primaryKey: "idCommandite" });
  const { selectedDataRow: selectedCommandite, setMainForm, mode, setMode, isFieldModifier, setIsFieldModifier, onFieldDataChanged, setSelectedDataRow } = clientFormDataSource;
  const [imageSrc, setImageSrc] = useState<string | null>(null);
  //TODO latence quand on switch entre commandite et autre rapidement

  const fileUploaderRef = useRef<any>(null);
  const formRef = useRef<any>(null);

  const nomEntrepriseOptions = useMemo(() => {
    return { maxLength: 50 };
  }, []);
  const afficherNomEntrepriseOptions = useMemo(() => {
    return { text: "Afficher le nom de l'entreprise" };
  }, []);
  const positionOptions = useMemo(() => {
    return {
      min: 0,
      max: 4,
      showSpinButtons: true,
      width: 65,
      inputAttr: { style: 'text-align: right; padding-inline-end: 0px;' }
    };
  }, []);

  useEffect(() => {
    if (selectedCommandite.logo) {
      console.log('ddddddd', selectedCommandite.logo.length > 0, imageSrc)
      if (selectedCommandite.logo.length > 0) {
        setImageSrc(`data:image/jpeg;base64,${selectedCommandite.logo}`);
      } else {
        setImageSrc("")
      }
    } else {
      setImageSrc(null);
    }
  }, [selectedCommandite]);

  const onFileUploaded = (e: any) => {
    const file = e.value[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        const result = event.target?.result as string;
        const base64 = result.split(',')[1];
        setImageSrc(result);
        setSelectedDataRow((prevState) => (
          {
            ...prevState,
            logo: base64
          }
        ))
        setIsFieldModifier(true)
      };
      reader.readAsDataURL(file);
    }
  };

  const deleteImage = () => {
    setImageSrc(null);
    setIsFieldModifier(true);
    setSelectedDataRow((prevState) => ({
      ...prevState,
      logo: ''
    }))
    // renitialise le fileUploader apres la suppression d'une image
    if (fileUploaderRef.current?.instance.reset()) {
      fileUploaderRef.current.instance.reset();
    }
  };

  const renderLogoCell = useCallback((cellData: DataGridTypes.ColumnCellTemplateData) => {
    if (cellData.data) {
      const imageSrc = `data:image/png;base64,${cellData.data.logo}`;
      return (
        <div style={{ textAlign: 'center' }}>
          {cellData.data.logo
            ? <img
              src={imageSrc}
              alt=""
              style={{ maxWidth: '40px', height: 'auto' }}
            />
            : '-'
          }
        </div>
      );
    } else {
      return null;
    }
  }, []);

  useEffect(() => {
    setMainForm(formRef.current?.instance());
  })

  useEffect(() => {
    if (mode !== Mode.Lecture) formRef.current?.instance().getEditor("nomEntreprise")?.focus();
  }, [mode])

  return (
    <FormListBase data={clientFormDataSource}>
      <FormListBaseGrid dataSource={clientFormDataSource.dataSource}
        onFocusedRowChanged={() => {
          if (mode === Mode.Modifier) setMode(Mode.Lecture);
        }}>
        <Column key={"grid-col-nom-entreprise"} dataField={"nomEntreprise"} caption="Entreprise" allowHiding={false} />
        <Column key={"grid-col-afficher-nom-entreprise"} dataField={"afficherNomEntreprise"} caption="Afficher nom entreprise" allowHiding={false} />
        <Column key={"grid-col-logo"} caption="Logo" allowHiding={false} cellRender={renderLogoCell} />
        <Column key={"grid-col-position"} dataField={"position"} caption="Position" allowHiding={false} />
      </FormListBaseGrid>
      <FormListBaseToolbar headerText={`${selectedCommandite?.nomEntreprise || ''}`} sauvegarderOptions={{ disabled: !isFieldModifier }} annulerOptions={{ disabled: !isFieldModifier }} />
      <FormListBaseTab>
        <TabItem title="Informations">
          <Form ref={formRef} readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedCommandite || {} as ICommandite} className={"forms"} labelLocation={"left"} showColonAfterLabel={true} onFieldDataChanged={onFieldDataChanged}>
            <SimpleItem key={"frm-nom-entreprise"} dataField={"nomEntreprise"} editorOptions={nomEntrepriseOptions}>
              <Label text={"Nom de l'entreprise"} />
            </SimpleItem>
            <SimpleItem key={"frm-afficher-nom-entreprise"} dataField={"afficherNomEntreprise"} editorType={"dxCheckBox"} editorOptions={afficherNomEntrepriseOptions}>
              <Label visible={false} />
            </SimpleItem>
            <SimpleItem key={"frm-position"} dataField={"position"} editorType={"dxNumberBox"} editorOptions={positionOptions} />
            <GroupItem caption={"Logo"}>
              <div style={{ display: 'flex' }}>
                <div>
                  <FileUploader
                    id={"photo-commandite"}
                    width={'120px'}
                    disabled={mode === Mode.Lecture}
                    ref={fileUploaderRef}
                    accept="image/*"
                    uploadMode="useForm"
                    onValueChanged={onFileUploaded}
                    selectButtonText="Changer…"
                    labelText=""
                    activeStateEnabled={false}
                    showFileList={false}
                  />
                </div>
                <div>
                  <Button
                    disabled={mode === Mode.Lecture}
                    text="Enlever"
                    onClick={deleteImage}
                    stylingMode="contained"
                  />
                </div>
              </div>
              {imageSrc && (
                <div style={{ marginTop: '20px', textAlign: 'center' }}>
                  <img
                    key={imageSrc}
                    src={imageSrc}
                    alt="Aperçu de l'image"
                    style={{ maxWidth: '50%', height: 'auto', border: '1px solid #ddd' }}
                  />
                </div>
              )}
            </GroupItem>
          </Form>
        </TabItem>
        <TabItem title="Système"><FormSysteme formData={selectedCommandite || {} as ICommandite} /></TabItem>
      </FormListBaseTab>
    </FormListBase>
  );
}